var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import { Button } from "@vapor/material";
let msgListener;
let closeHandler;
function attachEventListeners(onLoginSuccess, popupRef) {
    msgListener = (_a) => {
        var _b = _a.data, { type } = _b, data = __rest(_b, ["type"]);
        if (type === "TOKEN") {
            onLoginSuccess(data);
            popupRef.current && popupRef.current.close();
        }
    };
    closeHandler = () => {
        popupRef.current && popupRef.current.close();
    };
    window.addEventListener("message", msgListener);
    window.addEventListener("unload", closeHandler);
}
function removeEventListeners() {
    window.removeEventListener("message", msgListener);
    window.removeEventListener("unload", closeHandler);
}
const LoginButton = ({ buttonText = "Login", buttonVariant = "contained", className, displayedAppName, enableRetrieveCredentials = false, loginMethod = "TSID", loginUrl, flowType, onLoginSuccess, mode = "tab", popupHeight = 800, popupWidth = 900, userEmail, }) => {
    const popupRef = useRef();
    useEffect(() => () => removeEventListeners(), []);
    let windowOptions;
    if (mode === "popup") {
        windowOptions = `width=${popupWidth},height=${popupHeight}`;
    }
    let queryParameters = {
        appName: displayedAppName,
        enableRetrieveCredentials: enableRetrieveCredentials,
        flowType,
        loginMethod,
        userEmail,
    };
    const queryString = Object.entries(queryParameters)
        .filter(([_, value]) => value !== null && value !== undefined)
        .reduce((acc, [key, value]) => {
        acc.push(`${key}=${value}`);
        return acc;
    }, [])
        .join("&");
    return (_jsx(Button, Object.assign({ className: className, variant: buttonVariant, onClick: () => {
            popupRef.current = window.open(`${loginUrl}?${queryString}`, "sso", windowOptions);
            attachEventListeners(onLoginSuccess, popupRef);
        } }, { children: buttonText })));
};
export default LoginButton;
